import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './PublicOfferAgreementPage.css';

const PublicOfferAgreementPage = () => {
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const agreement = t('publicOfferAgreement', { returnObjects: true }) || {};
  const { title, sections } = agreement;

  const renderContent = (contentItem, index) => {
    switch (contentItem.type) {
      case 'paragraph':
        return <p key={index} dangerouslySetInnerHTML={{ __html: contentItem.text }} />;
      case 'list':
        return (
          <ul key={index}>
            {contentItem.items.map((item, i) => (
              <li key={i} dangerouslySetInnerHTML={{ __html: item }} />
            ))}
          </ul>
        );
      case 'details':
        return (
          <div key={index} className="details-section">
            {contentItem.lines.map((line, i) => (
              <p key={i}>{line}</p>
            ))}
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="public-offer-agreement-page-container">
      <h1 className="public-offer-agreement-page-title" style={{ whiteSpace: 'pre-line' }}>{title}</h1>
      {Array.isArray(sections) ? sections.map((section, index) => (
        <div key={index} className="agreement-section">
          <h2>{section.title}</h2>
          {Array.isArray(section.content) && section.content.map(renderContent)}
        </div>
      )) : <p>{t('publicOfferAgreement.comingSoon')}</p>}
    </div>
  );
};

export default PublicOfferAgreementPage; 